import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ISubCategories, ISubcategorySettings } from '@valhalla/data/entities';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { IApiResponse } from '../api-response';
import ApiVersion from '../api-versions';
import { DataHttpCommonService } from '../data-http-common.service';
import { EndpointUrlConfig } from '../endpoint.config';
import {
	CategoryDataHttpService,
	IDataSourceGetSmartExpressions,
	IDataSourceSaveSettingsParams,
	IGetDataSourceConfigResult,
	IGetSubcategoryStatesResult,
	ISubategoriesTree,
} from './abstract';

import type { IEndpointUrlConfig } from '../endpoint.config';
import type { ICategoryItem, ISelectCategoryCriteria } from './abstract';
@Injectable()
export class CategoryDataHttpServiceImpl implements CategoryDataHttpService {
	constructor(
		@Inject(EndpointUrlConfig) public readonly config: IEndpointUrlConfig,
		public readonly http: HttpClient,
		public readonly common: DataHttpCommonService
	) {}

	selectCatSubcat(settings: ISelectCategoryCriteria): Observable<ICategoryItem[]> {
		const url = this.common.getApiUrl('selectCatSubcat', ApiVersion.v10);
		return this.http.post<ICategoryItem[]>(url, { settings: settings });
	}

	storageSubCategory(subcatId: number): Observable<ISubCategories> {
		const url = this.common.getApiUrl(`storage/subcategories/${subcatId}`);
		return this.http.get<IApiResponse<ISubCategories>>(url).pipe(map(r => r.data));
	}

	subcategoriesTree(): Observable<ISubategoriesTree> {
		const url = this.common.getApiUrl('subcategories/tree', ApiVersion.v10);
		return this.http.get<ISubategoriesTree>(url);
	}

	subcategoryStates(subcatId: number): Observable<IGetSubcategoryStatesResult> {
		const url = this.common.getApiUrl(`subcategory/${subcatId}/states`, ApiVersion.v10);
		return this.http.get<IGetSubcategoryStatesResult>(url);
	}

	dataSourceConfig(subcatId: number): Observable<IGetDataSourceConfigResult> {
		const url = this.common.getApiCoreUrl(`datasource/subcat/${subcatId}/config`);
		return this.http.get<IGetDataSourceConfigResult>(url);
	}

	dataSourceRows(subcatId: number, params: any): Observable<any> {
		const url = this.common.getApiCoreUrl(`datasource/subcat/${subcatId}/data`);
		return this.http.post<any>(url, params);
	}

	dataSourceSaveSettings(params: IDataSourceSaveSettingsParams): Observable<any> {
		const url = this.common.getApiCoreUrl(`datasource/settings/save`);
		return this.http.post<any>(url, params);
	}

	smartExpressions(criteria: IDataSourceGetSmartExpressions) {
		if (criteria?.subcatId) {
			const url = this.common.getApiCoreUrl(`datasource/${criteria?.subcatId}/smartexpressions`);
			return this.http.get<any[]>(url);
		}
		return of([]);
	}

	updateSubcategorySettings(criteria: ISubcategorySettings, subcatId: number) {
		const url = this.common.getApiUrl(`subcategories/${subcatId}/settings/update`);
		return this.http.post<any>(url, criteria);
	}
}
